export default __webpack_public_path__ + "static/media/arrTopLight.5dc1a82f.svg";